import { intervalToDuration } from "date-fns";

import { t } from "@/i18n-js/instance";

export const getPollTimeRemaining = (
  closesAt: string | null | undefined,
): string | undefined => {
  if (!closesAt) return undefined;

  const closesAtDate = new Date(closesAt);
  const now = new Date();

  if (closesAtDate <= now) {
    return t("tiptap.extensions.poll.closed");
  }

  const { days, hours, minutes, seconds } = intervalToDuration({
    start: now,
    end: closesAtDate,
  });

  if (days) return t("tiptap.extensions.poll.remaining_days", { count: days });
  if (hours) {
    return t("tiptap.extensions.poll.remaining_hours", { count: hours });
  }
  if (minutes) {
    return t("tiptap.extensions.poll.remaining_minutes", { count: minutes });
  }
  if (seconds) {
    return t("tiptap.extensions.poll.remaining_seconds", { count: seconds });
  }

  return t("tiptap.extensions.poll.closed");
};
